import {JsonProperty} from "json-object-mapper";
import {noop} from "rxjs";

export class AllowAll {
  @JsonProperty() public enabled: boolean;
  @JsonProperty() public label?: string;
  @JsonProperty() public value?: string | number;
  @JsonProperty() public init?: () => void;

  constructor() {
    this.enabled  = false;
    this.label    = null;
    this.value    = null;
    this.init     = noop;
  }
}
